import { useDeleteShape } from "http-hooks/shape/useShape";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteShape({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteShape();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Shape"
      description="Are you sure you want to delete this Shape? This Shape will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
